import React from 'react'

function Careers() {
  return (
    <div>
      Careers Page
    </div>
  )
}

export default Careers
